var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-wrapper"},[_c('Header',{attrs:{"parent":_vm.$route.query.from},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h4',{staticClass:"qrw-heading-xs"},[_vm._v("\n        "+_vm._s(_vm.$t("tables.payments_history"))+"\n      ")])]},proxy:true}])}),_c('IQOSTable',{attrs:{"cols":[
      {
        title: _vm.$t('subscription.transactions.number'),
        key: 'banking_id',
      },
      {
        title: _vm.$t('subscription.transactions.date'),
        key: 'created_at',
        date: true
      },
      {
        title: _vm.$t('subscription.transactions.time'),
        key: 'created_at',
        time: true,
        width: 80
      },
      {
        title: _vm.$t('subscription.transactions.system'),
        key: 'system',
        renderer: _vm.formatSystemName,
      },
      {
        title: _vm.$t('subscription.transactions.method'),
        key: 'pay_method',
        renderer: function (t) { return ((t.card_type.toUpperCase()) + " " + (t.card_mask)); },
      },
      {
        title: _vm.$t('subscription.transactions.sum'),
        key: 'amount_usd',
        default: '0',
        unit: '$',
        width: 120
      },
      {
        title: _vm.$t('subscription.transactions.status'),
        key: 'status',
      } ],"rows":_vm.transactions},scopedSlots:_vm._u([{key:"col-status",fn:function(slotProps){return [(slotProps.rowItem.status == 'success')?_c('span',{staticClass:"green-5-color"},[_vm._v(_vm._s(_vm.$t("subscription.transactions.success")))]):(slotProps.rowItem.status == 'reversed')?_c('span',{staticClass:"v1-grey-10-color"},[_vm._v(_vm._s(_vm.$t("subscription.transactions.reversed")))]):_c('span',{staticClass:"red-4-color"},[_vm._v(_vm._s(_vm.$t("subscription.transactions.error")))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }